import { createContext, useContext, useState, useCallback } from 'react'

const MapSpotContext = createContext()

export function MapSpotProvider({ children }) {
  const [isSpotModeActive, setIsSpotModeActive] = useState(false)
  const [spotModeCallback, setSpotModeCallback] = useState(null)
  const [preSelectedEntity, setPreSelectedEntity] = useState(null)
  const [initialLocation, setInitialLocation] = useState(null)
  const [spotVariant, setSpotVariant] = useState('spot') // 'spot' | 'listing'

  const activateSpotMode = useCallback((callback, entity = null, location = null, variant = 'spot') => {
    setIsSpotModeActive(true)
    setSpotVariant(variant)
    if (callback) {
      setSpotModeCallback(() => callback)
    }
    if (entity) {
      setPreSelectedEntity(entity)
    }
    if (location) {
      setInitialLocation(location)
    }
  }, [])

  const deactivateSpotMode = useCallback(() => {
    setIsSpotModeActive(false)
    setSpotModeCallback(null)
    setPreSelectedEntity(null)
    setInitialLocation(null)
    setSpotVariant('spot')
  }, [])

  const value = {
    isSpotModeActive,
    activateSpotMode,
    deactivateSpotMode,
    spotModeCallback,
    preSelectedEntity,
    initialLocation,
    spotVariant,
  }

  return (
    <MapSpotContext.Provider value={value}>
      {children}
    </MapSpotContext.Provider>
  )
}

export function useMapSpot() {
  const context = useContext(MapSpotContext)
  if (!context) {
    throw new Error('useMapSpot must be used within MapSpotProvider')
  }
  return context
}
